export const therapists = [
    { name: "Test User - James", email: "jshu@plutonic.co" },
    { name: "Jeanette Gurr", email: "jgurr@plutonic.co" },
    { name: "Abigail Rozeboom", email: "arozeboom@plutonic.co" },
    { name: "Ashi Patel", email: "apatel@plutonic.co" },
    { name: "Stephanie Branom", email: "sbranom@plutonic.co" },
    { name: "Cooper Morgan", email: "cmorgan@plutonic.co" },
    { name: "Michelle Lake", email: "mlake@plutonic.co" },
    { name: "Briauna Brownfield, LMSW", email: "briaunaterie@gmail.com" },
    { name: "Kazia Cortel-Fraser", email: "kcortelfraser@plutonic.co" },
    { name: "Janay Holland", email: "janay1106@gmail.com" },
    { name: "Yushea Miller", email: "yusheawilliams@gmail.com" },
    { name: "Grace Lee", email: "gracejunghyun@gmail.com" },
    { name: "Sarah Burgess", email: "sarahburgess202@gmail.com" },
    { name: "Rachel Jacobs", email: "drjacobs@wellbraintherapy.com" },
    { name: "Shaina Page", email: "shainapage1@gmail.com" },
    { name: "Alycia Shaheed", email: "alyciashaheed@gmail.com" },
    { name: "Amber Reakes", email: "amberreakes@gmail.com" },
    { name: "Kathryn Walker", email: "kathrynw11@yahoo.com" },
    { name: "Talisa Burke", email: "talisa.burke@gmail.com" },
    { name: "Larry Benz", email: "larry@physicaltherapist.com" },
    { name: "Eduardo Argueta Flores", email: "earguetaflores@gmail.com" },
    { name: "Robin Carter", email: "rccarter25@gmail.com" },
    { name: "Test User - Matthew", email: "mjwebster61@outlook.com" },
    { name: "Test User - Andrew", email: "andrewpaulphipps@gmail.com" },
  ];
